export default __webpack_public_path__ + "static/media/sensotrend_signin_signup.afe31c8e.png";